import { render, staticRenderFns } from "./workout-item.vue?vue&type=template&id=36c41920&"
import script from "./workout-item.vue?vue&type=script&lang=js&"
export * from "./workout-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports